module.exports = __webpack_public_path__ + "img/efectivo verde.a42f00dc.svg";